import { render, staticRenderFns } from "./MessagesSystemGroup.vue?vue&type=template&id=ef29f4fa&scoped=true"
import script from "./MessagesSystemGroup.vue?vue&type=script&lang=js"
export * from "./MessagesSystemGroup.vue?vue&type=script&lang=js"
import style0 from "./MessagesSystemGroup.vue?vue&type=style&index=0&id=ef29f4fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef29f4fa",
  null
  
)

export default component.exports